import { render, staticRenderFns } from "./FillBlank.vue?vue&type=template&id=2f601b57&"
import script from "./FillBlank.vue?vue&type=script&lang=js&"
export * from "./FillBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f601b57')) {
      api.createRecord('2f601b57', component.options)
    } else {
      api.reload('2f601b57', component.options)
    }
    module.hot.accept("./FillBlank.vue?vue&type=template&id=2f601b57&", function () {
      api.rerender('2f601b57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/FillBlank.vue"
export default component.exports